<template>
  <SalesPanel v-if="display">
    <template #header>
      <div class="flex justify-between">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Studio Pro aktivieren
        </h3>
      </div>
    </template>
    <template #default>
      <div class="divide-y divide-gray-200">
        <div class="block hover:bg-gray-50">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="flex flex-col">
                <p class="block text-sm font-medium text-gray-600 mb-4">
                  Schalte dir jetzt alle interaktiven Features wie Experimente, Benachrichtigungen und deinen persönlichen KI-Assistenten frei.
                </p>
                <SalesButton @click="click">
                  Ich möchte mit Anleitung wachsen
                </SalesButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SalesPanel>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps({podcast: Object});
const router = useRouter();

const display = computed(() => ! props.podcast.active);

const click = () =>
{
  const name = {name: 'podcasts.conversion'};
  const params = {params: {id: props.podcast.id}};
  router.push({...name, ...params});
};
</script>